module.exports = __webpack_public_path__ + "static/fonts/Roboto-Regular.4d3ab24.otf";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/font/roboto/Roboto-Regular.otf
// module id = Ahlm
// module chunks = 0